import { Badge } from "@/core/components/ui/badge";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { RUN_STATUS_META } from "@/profitability/constants";
import { ReportActions } from "@/profitability/report-actions";
import type { EnrichedProfitabilityRun } from "@/profitability/types";
import { BackToReports } from "./back-to-reports";
import { RunHeadline } from "./run-headline";
export const RunHeader = ({
  businessId,
  run,
  onOpenChat,
}: {
  businessId: string;
  run: EnrichedProfitabilityRun;
  onOpenChat: () => void;
}) => {
  const statusMeta = RUN_STATUS_META[run.status];
  return (
    <Stack gap="sm" className="flex-none py-4" fullWidth>
      <BackToReports />
      {/* Opening the chat takes ~436px out of this row, so the figures and
              actions wrap under the period rather than squeezing it. */}
      <Stack
        direction="row"
        justify="between"
        align="center"
        gap="md"
        fullWidth
        className="flex-wrap gap-y-3"
      >
        <Stack gap="xs">
          <Stack direction="row" align="center" gap="sm">
            <Typography variant="titleW3" className="whitespace-nowrap">
              {run.display.period}
            </Typography>
            <Badge variant={statusMeta.variant} size="sm">
              {statusMeta.label}
            </Badge>
          </Stack>
          <Typography variant="bodyW3" textColor="secondary">
            {run.display.metadata}
          </Typography>
        </Stack>
        <Stack
          direction="row"
          align="center"
          gap="lg"
          className="flex-wrap gap-y-3"
        >
          <RunHeadline run={run} />
          {run.display.workbookReady && (
            <ReportActions
              businessId={businessId}
              run={run}
              onOpenChat={onOpenChat}
            />
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};
